import { render, staticRenderFns } from "./PlantEntryAmendmentHistoryModal.vue?vue&type=template&id=a6434152&scoped=true"
import script from "./PlantEntryAmendmentHistoryModal.vue?vue&type=script&lang=js"
export * from "./PlantEntryAmendmentHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./PlantEntryAmendmentHistoryModal.vue?vue&type=style&index=0&id=a6434152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6434152",
  null
  
)

export default component.exports